import { render, staticRenderFns } from "./EstadoLegal.vue?vue&type=template&id=70476459&scoped=true"
import script from "./EstadoLegal.vue?vue&type=script&lang=js"
export * from "./EstadoLegal.vue?vue&type=script&lang=js"
import style0 from "./EstadoLegal.vue?vue&type=style&index=0&id=70476459&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70476459",
  null
  
)

export default component.exports